import { PropsWithChildren } from 'react';
import { Stack, SvgIcon, Typography } from '@mui/material';
import { ReactComponent as IconParcel } from '@qb/frontend/icons/icon-parcel.svg';
import { PartPublicQtyAndPriceResponse } from '@/shared/types/controllers/sps/SPSPartControllerTypes';
export const TrustBoxPriceDetailsShipWithinLabelContainer = ({
  children
}: PropsWithChildren) => <Stack direction={['row', 'row', 'row-reverse']} sx={{
  alignItems: 'center',
  bgcolor: 'success.12p',
  borderRightStyle: 'solid',
  borderRightWidth: [0, 0, 8],
  borderRightColor: 'success.main',
  py: [1, 1, 1.5],
  pr: 1.5,
  pl: [0.5, 0.5, 1.5],
  mb: [1, 1, 0],
  width: ['fit-content', 'fit-content', '100%']
}} data-sentry-element="Stack" data-sentry-component="TrustBoxPriceDetailsShipWithinLabelContainer" data-sentry-source-file="TrustBoxPriceDetailsShipWithinLabel.tsx">
    <SvgIcon component={IconParcel} inheritViewBox sx={{
    color: 'success.main',
    fontSize: 32
  }} data-sentry-element="SvgIcon" data-sentry-source-file="TrustBoxPriceDetailsShipWithinLabel.tsx" />
    <Typography variant="h6" component="p" sx={{
    mr: [0, 0, 1.5],
    ml: [1, 1, 0]
  }} data-sentry-element="Typography" data-sentry-source-file="TrustBoxPriceDetailsShipWithinLabel.tsx">
      {children}
    </Typography>
  </Stack>;
export const TrustBoxPriceDetailsShipWithinLabel = ({
  onHandQty,
  manufacturerStock,
  shipProcessingDays
}: Pick<PartPublicQtyAndPriceResponse, 'shipProcessingDays' | 'onHandQty' | 'manufacturerStock'>) => {
  // Default value
  const text = (() => {
    if (shipProcessingDays === 0 && onHandQty) {
      return 'This item can ship within 24h!';
    } else if (!onHandQty && manufacturerStock) {
      return 'This item can ship in 3-5 days!';
    }
    return `This item can ship within ${shipProcessingDays} day${shipProcessingDays > 1 ? 's' : ''}!`;
  })();
  return <TrustBoxPriceDetailsShipWithinLabelContainer data-sentry-element="TrustBoxPriceDetailsShipWithinLabelContainer" data-sentry-component="TrustBoxPriceDetailsShipWithinLabel" data-sentry-source-file="TrustBoxPriceDetailsShipWithinLabel.tsx">
      {text}
    </TrustBoxPriceDetailsShipWithinLabelContainer>;
};